<template>
  <w-flex class="app-logo" justify="center">
    <img src="../../assets/witkac_generator_biale.png" />
  </w-flex>
</template>

<style lang="scss">
.app-logo {
  max-width: 100%;
  margin: 10px 0;

  img {
    width: 100%;
    max-width: w.size('logo-max-width');
    object-fit: contain;

    @include w.media-xl {
      max-width: w.size('logo-max-width--xl');
    }
  }
}
</style>
